<p class="tn-text-big tn-text-green">
    Opening hours
</p>

<ng-template
        ngFor let-avail let-i="index" [ngForOf]="availabilityArray" let-last=last>
<span class="tn-text-big">{{avail.day | titleCaseExtendedPipe}}</span> : <span >{{avail.status}}</span> <span *ngIf="!last">,</span>
</ng-template>

